// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-label[data-v-25152baa]{font-weight:700;margin-bottom:0;margin-right:15px}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Employee/View.vue"],"names":[],"mappings":"AACA,6BACI,eAAA,CAEA,eAAA,CADA,iBACJ","sourcesContent":["\n.form-label{\n    font-weight: bold;\n    margin-right: 15px;\n    margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
